import * as XLSX from 'xlsx'
import fs from 'file-saver'

export const getExcelFileData = (file: any) => {
  return new Promise((resolve, reject) => {
    // 获取上传的文件对象
    // 通过FileReader对象读取文件
    const fileReader = new FileReader()
    fileReader.onload = (event: any) => {
      try {
        const { result } = event.target
        // 以二进制流方式读取得到整份excel表格对象
        const workbook = XLSX.read(result, { type: 'binary' })
        let data: any = []// 存储获取到的数据
        // 遍历每张工作表进行读取（这里默认只读取第一张表）
        for (const sheet in workbook.Sheets) {
          if (Object.prototype.hasOwnProperty.call(workbook.Sheets, sheet)) {
            // 利用 sheet_to_json 方法将 excel 转成 json 数据
            data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            break // 如果只取第一张表，就取消注释这行
          }
        }
        resolve(data)
      } catch (e) {
        // 这里可以抛出文件类型错误不正确的相关提示
        reject(new Error('文件类型不正确'))
      }
    }
    // 以二进制方式打开文件
    const blobFile = new Blob([file], { type: 'text/plain;charset=utf-8' })
    fileReader.readAsBinaryString(blobFile)
  })
}

export const excelExport = function ({
  headers = [],
  contents = [],
  fileName = '表格'
} :any) {
  /**
   * 表头
   * headers Array<Object>: [{title:String, dataIndex: String}] 表头内容部分
   * isNotExport 属性可过滤导入字段
   * 可以直接使用 antDesign table 的 columns
   * title String：每列的中文名称
   * dataIndex String: 每列对应用的取值 key
   * **/
  headers = headers.filter((item: any) => {
    return !item.isNotExport
  })
  // 使用 headers download 函数需要的表头格式
  const _headers = headers.reduce((pre:any, item: any) => {
    const obj = {
      [item.title]: item.title
    }
    pre = Object.assign(pre, obj)
    return pre
  }, {})
  /**
   * 列表内容
   * contents Array<content>: 列表内容部分 可以直接使用 antDesign table 的 dataSource
   * content Object: 每一行打印详情
   * **/
  // 使用 contents download 函数需要的内容格式
  const _contents = contents.map((item:any, index:any) => {
    return headers.reduce((pre:any, temp: any) => {
      const obj: any = {
        [temp.title]:
          item[temp.dataIndex] ||
          (item[temp.dataIndex] === 0 ? item[temp.dataIndex] : '')
      }
      if (temp.customRender) {
        obj[temp.title] = temp.customRender(item[temp.dataIndex], item, index)
      }
      pre = Object.assign(pre, obj)
      return pre
    }, {})
  })
  /**
   * 表头
   * fileName String: 列表名
   * 无需加 .xlsx 后缀
   * **/
  console.log([_headers, ..._contents])
  // return;
  download([_headers, ..._contents], fileName)
}

export const download = (json: any, fileName: string) => {
  // 获取表格头
  const headerKeys = Object.keys(json[0])

  // 需要导出数据 给 XLSX 插件的映射（也就是参数）
  const tmpData: any = {}
  json.forEach((temp: any, index: any) => {
    headerKeys.forEach((item, indexSon) => {
      tmpData[getCharCol(indexSon) + `${index + 1}`] = { v: temp[item] }
    })
  })

  // 设置区域,比如表格从A1到D10
  const outputPos = Object.keys(tmpData)

  // XLSX 插件，生成文件所需参数
  const tmpWB = {
    SheetNames: ['mySheet'], // 保存的表标题
    Sheets: {
      mySheet: Object.assign({},
        tmpData, // 内容
        {
          '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
        })
    }
  }
  const wopts: any = {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  }
  const wbout: any = XLSX.write(tmpWB, wopts)
  const tmpDown = new Blob([s2ab(wbout)], { type: 'application/octet-stream' }) // 创建二进制对象写入转换好的字节流
  fs.saveAs(tmpDown, fileName + '.xlsx')
}

function getCharCol (n: any) {
  let s = ''; let m = 0
  if (n === 0) s = 'A'
  while (n > 0) {
    m = n % 26 + 1
    s = String.fromCharCode(m + 64) + s
    n = (n - m) / 26
  }
  return s
}
function s2ab (s: any): any { // 字符串转字符流
  let buf
  if (typeof ArrayBuffer !== 'undefined') {
    buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  } else {
    buf = new Array(s.length)
    for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
    return buf
  }
}
